/**
 * @memberof system-metadata
 * @enum {string}
 * @property {string} POPULATION
 * @property {string} HOUSEHOLD
 * @property {string} HOUSEUNIT
 */
var ApportionmentType;
(function (ApportionmentType) {
    ApportionmentType["POPULATION"] = "pop";
    ApportionmentType["HOUSEHOLD"] = "household";
    ApportionmentType["HOUSEUNIT"] = "houseunit";
    ApportionmentType["PROPERTY"] = "property";
})(ApportionmentType || (ApportionmentType = {}));
ApportionmentType[ApportionmentType.POPULATION] = ApportionmentType.POPULATION;
ApportionmentType[ApportionmentType.HOUSEHOLD] = ApportionmentType.HOUSEHOLD;
ApportionmentType[ApportionmentType.HOUSEUNIT] = ApportionmentType.HOUSEUNIT;
ApportionmentType[ApportionmentType.PROPERTY] = ApportionmentType.PROPERTY;
export default ApportionmentType;
